<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: webinarIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="bullhorn"
      :style="{ color: webinarIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Webinar</span>
  </div>
</template>

<script>
export default {
  props: ["webinarIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
